import {
  createContext,
  useContext,
  useEffect,
  useState,
  useRef,
  useCallback,
} from "react";
import { useWallet } from "@providers/wallet.provider";
import { ConnectedWallet } from "@goblinhunt/cosmes/wallet";
import { ActionService } from "@api/account.service";
import useAlert from "@hooks/AlertHook";
import type { UserResponse } from "baaanggg";

export type AccountContextProps = {
  user?: UserResponse;
  wallet?: ConnectedWallet;
  address?: string;
  refreshAccount: () => void;
};

export const AccountContext = createContext<AccountContextProps>({
  user: undefined,
  wallet: undefined,
  address: undefined,
  refreshAccount: () => {},
});
export const useAccount = () => useContext(AccountContext);

export const AccountContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { address, wallet } = useWallet();
  const api = new ActionService();
  const alert = useAlert();

  const [user, setUser] = useState<UserResponse>();
  const isFetchingRef = useRef(false); // anti dobel fetch

  const fetchAccount = useCallback(
    async (force = false) => {
      if (!address) return;
      if (isFetchingRef.current) return;
      if (!force && user?.walletAddress === address) return;

      isFetchingRef.current = true;
      try {
        // 1) coba ambil user
        let fetched = await api.get();
        console.log(fetched);
        // 2) kalau belum ada / 401 -> sign in dulu, lalu get ulang
        if (!fetched && wallet) {
          await api.signIn(alert, wallet, address, () => {}); // kamu sudah punya ini di service-mu
          fetched = await api.get();
        }

        setUser(fetched);
      } catch (e) {
        console.log("fetchAccount error:", e);
      } finally {
        isFetchingRef.current = false;
      }
    },
    [address, user?.walletAddress, api]
  );

  // Jalan saat mount & saat address berubah
  useEffect(() => {
    if (address) fetchAccount();
  }, [address, fetchAccount]);

  // Kalau awalnya user undefined tapi address sudah ada, cek lagi sekali
  useEffect(() => {
    if (address && user === undefined) {
      fetchAccount();
    }
  }, [address, user, fetchAccount]);

  // Optional: recheck saat tab balik fokus (user bisa logout/login di tab lain)
  useEffect(() => {
    if (address) fetchAccount();
  }, [fetchAccount]);

  return (
    <AccountContext.Provider
      value={{
        user,
        wallet, // <- isi dengan ConnectedWallet (bukan string address)
        address,
        refreshAccount: () => fetchAccount(true),
      }}
    >
      {children}
    </AccountContext.Provider>
  );
};
